import gql from "graphql-tag";

export default gql`
  query getTenantTaskByToken($token: String!, $query: QueryInput, $offset: OffsetInput) {
    getTenantTaskByToken(token: $token, query: $query, offset: $offset) {
      __typename
      id
      task
      property
      property_name
      category
      reference_doc
      reference_doc_section
      required_docs
      effective_period
      due_dates
      due_dates_rrule
      contact_email
      notify_email
      user
      archived
    }
  }
`;
